module.exports = __webpack_public_path__ + "img/solition_level.83f545d.83f545d8.jpg";